export default __webpack_public_path__ + "static/media/proto.901182c1.png";